import type { ReactNode } from 'react';
import classNames from 'classnames';
import { SkeletonLine } from '@/shared/components/atoms/LoadingSkeleton';
import Pill, { type PillProps } from '@/shared/components/flip-ui-kit/Pill';
import QuestionMarkTooltip from '@/shared/components/QuestionMarkTooltip';

const Card = ({
  icon,
  children,
  title,
  loading,
  tooltip,
  tooltipLink,
  footer,
  skeletonLineWidth,
  className,
  titleClassName,
  childrenContainerClassName = 'text-20 text-cf-light-4',
  pillProps,
  headerAction,
  itemsCentered = false,
}: {
  children: ReactNode;
  icon?: React.JSX.Element;
  title?: string;
  loading?: boolean;
  tooltip?: string;
  tooltipLink?: string;
  footer?: ReactNode;
  skeletonLineWidth?: number;
  className?: string;
  titleClassName?: string;
  childrenContainerClassName?: string;
  pillProps?: PillProps;
  headerAction?: ReactNode;
  itemsCentered?: boolean;
}) => (
  <div
    className={classNames(
      'flex grow flex-col gap-y-2 rounded-md border border-cf-gray-3-5 bg-cf-gray-3 p-5',
      itemsCentered ? 'justify-center' : 'justify-between',
      className,
    )}
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-1">
        {/* dummy div to prevent the icon from scaling when it gets squished */}
        <div>{icon}</div>
        <span
          className={classNames('font-aeonikMedium text-14', titleClassName ?? 'text-cf-light-2')}
        >
          {title}
        </span>
        <QuestionMarkTooltip content={tooltip} link={tooltipLink} />
      </div>
      {headerAction}
      {pillProps && <Pill {...pillProps} />}
    </div>
    <div
      className={classNames(
        'font-aeonikMedium',
        childrenContainerClassName,
        !itemsCentered && 'grow',
      )}
    >
      {loading ? <SkeletonLine width={skeletonLineWidth} /> : children}
    </div>
    <div className="text-12 text-cf-light-2">{footer}</div>
  </div>
);

export default Card;
